import React from 'react';
import { BrowserRouter } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { UserContextProvider } from './UserContext';
// import ResetPassword from "./components/ResetPassword";


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <BrowserRouter >
   {/* <Routes>
      <Route path="/password-reset/:encoded_pk/:token" element={<ResetPassword />} />
  </Routes> */}
    <UserContextProvider>
      <App />
    </UserContextProvider>
  </BrowserRouter>
  //  </React.StrictMode>
);
